import React from 'react';
import { VictoryPie } from 'victory';
import { MeasurementHelper } from '../../../lib/helpers/measurementHelper';

const BinaryData: React.FC<{ helper: MeasurementHelper }> = ({ helper }) => (
  <div style={{ width: 23, height: 23 }}>
    <VictoryPie
      data={helper.pieChart().data}
      colorScale={helper.pieChart().colorsBinary}
      padding={0}
      labels={[]}
      animate={{
        duration: 500,
        onLoad: { duration: 750 }
      }}
    />
  </div>
);

export default BinaryData;
